import { helper } from '@ember/component/helper';
import { formatDate } from './format-date';

export const niceDate = ([date]) => {
  if (!date) return;
  return formatDate([new Date(date), 'MMM dd, yyyy']);
};

export default helper(niceDate);
